"use strict";

var curryN = require('../function/curryN');
var objectKeys = require('./keys');
/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @param {Array} props an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @example
 *
 *      omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */
module.exports = curryN(2, function (props, obj) {
  if (props === void 0) {
    props = [];
  }
  if (obj === void 0) {
    obj = {};
  }
  var propsSet = Object.create(null);
  for (var i = 0; i < props.length; i++) {
    propsSet[props[i]] = true;
  }
  var result = {};
  var keys = objectKeys(obj);
  for (var _i = 0; _i < keys.length; _i++) {
    var prop = keys[_i];
    if (!propsSet[prop]) {
      result[prop] = obj[prop];
    }
  }
  return result;
});